<template>
  <div>
    <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">Details</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-body table-responsive p-0 table-striped table-hover table-bordered">
                <table class="table table-head-fixed table-hover-animation text-nowrap">
                  <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Name</th>
                    <th>Type</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="index" v-for="(row, index) in list">
                    <td>{{ index + 1 }}</td>
                    <td>{{ row.card_meta_data_name }}</td>
                    <td>{{ row.card_meta_data_type_name }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="$emit('hide')">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ["show", "data", "index"],
  data() {
    return {
      list: []
      // showModal: false,
    };
  },
  methods:{
    getCharges(chargeId){
      this.makeRequest("post", "v1/get-charges", {chargeId: chargeId}, {}, false,true,[205]).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = []
                data = callResponse.response.data.data;
                if(data){
                  this.list = data
                }

              }
            }
          }
      );
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.getCharges(this.data);
      }
    },
  }
};
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>

